<template>
  <div style="padding-top: 20px;">
        <div style="margin-top: 20px;text-align: center;">
          <div class="diseaseTab" v-for="(item,index) in diseaseList" :key="index" :class="{ diseaseTabAct: item.selected == true}" @click="selectedClick(index)">{{item.tagName}}</div>
        </div>
        <div class="add1" @click="sure()">确定</div>
  </div>
</template>

<script>
import { medicaltag, getUserMedicalTag, uphealthinfo2 } from '@/api/activity'
export default {
  data() {
    return {
      diseaseList:[],
      disease:0,
      list:[],
    };
  },

  mounted() {
    document.title = '疾病史选择'
   
    medicaltag().then((res)=>{
      if(res.code == 1000) {
        for(var i = 0; i<res.data.length; i++) {
          res.data[i].selected = false
        }
        this.diseaseList = res.data
        // 个人疾病标签接口按类型查询，1001 对应本页需要展示的疾病标签。
        getUserMedicalTag({ type: '1001' }).then((res1)=>{
          if(res1.code == 1000) {
            for(var i = 0; i<res1.data.length; i++) {
              res1.data[i].selected = true
            }
            this.list = res1.data
          }
          for (let i = 0; i < this.diseaseList.length; i++) {
          for (let j = 0; j < this.list.length; j++) {
            if (this.diseaseList[i].tagCode === this.list[j].tagCode) {
              this.diseaseList[i].selected = true
              // indices.push(i); // 只记录第一次出现的下标，如果要记录所有，可以添加条件来避免重复添加相同的下标。
              // break; // 如果只需要找到第一个匹配项的下标，可以使用break退出内层循环。
            }
          }
        }
        })
      }
      console.log(res)
    })
  },
  components: {
  },
  computed: {
  },
  methods: {
    selectedClick(index) {
      console.log(index)
      this.diseaseList[index].selected = !this.diseaseList[index].selected
    },
    sure() {
      this.list = []
      for(var i = 0; i<this.diseaseList.length; i++) {
        if(this.diseaseList[i].selected) {
          this.list.push(this.diseaseList[i])
        }
      }
      var obj = {
        medHis:true,
        tagParamList:this.list,
        userCode: localStorage.getItem('userCode'),
      }
      uphealthinfo2(obj).then((res)=>{
        console.log(res)
      })
      this.$router.push({
              path: "/information",
              query:{
              }
            });
       console.log(this.list)
    }
  }
};
</script>
<style scoped>
.jiazu {
  width:300px !important;
  height: 100px !important;
}

.diseaseTab {
  width: 155px;
  height: 50px;
  display: inline-block;
  border: 2px solid #ccc;
  text-align: center;
  line-height: 46px;
  border-radius: 10px;
  margin:5px
}

.sdiseaseDiv {
  width: 80%;
  height: 80px;
  text-align: center;
  border: 3px solid #ccc;
  line-height: 77px;
  margin: 0 auto;
  margin-top:20px;
  font-size:18px
}

.diseaseTabAct {
  border: 2px solid #00c275;
  color: #00c275;
}

.add1 {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  border: 1px solid #00c275;
  padding: 10px 0px;
  border-radius: 48px;
  color: #fff;
  background-color: #00c275;
  margin-top: 20px;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/information/disease.vue